module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "our-services",
    attrs: {
      "id": "our-services"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "service-heading"
  }, [_vm._v("MikMak Services")]), _vm._v(" "), _c('Blob'), _vm._v(" "), _c('div', {
    staticClass: "service-wrapper"
  }, _vm._l((_vm.List), function(service) {
    return _c('div', {
      staticClass: "service-item-block"
    }, [_c('h1', {
      domProps: {
        "innerHTML": _vm._s(service.name)
      }
    }), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(service.text)
      }
    }), _vm._v(" "), _vm._l((service.bullets), function(bullet) {
      return _c('span', {
        staticClass: "bullet-item",
        domProps: {
          "innerHTML": _vm._s(("&middot; " + bullet))
        }
      })
    }), _vm._v(" "), (service.videoUrl) ? _c('div', {
      staticClass: "video-wrapper"
    }, [_c('img', {
      staticClass: "video-device",
      attrs: {
        "src": require("../../../assets/winter-2019/hero-phone-16.png")
      }
    }), _vm._v(" "), _c('video', {
      staticClass: "video-element",
      attrs: {
        "src": service.videoUrl,
        "muted": "",
        "playsinline": "",
        "autoplay": "",
        "loop": ""
      },
      domProps: {
        "muted": true
      }
    })]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#contact-footer",
        "type": "button",
        "name": "button"
      },
      domProps: {
        "innerHTML": _vm._s(service.buttonText)
      }
    })], 2)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef440326"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/Services/Services.vue
// module id = 506
// module chunks = 0